const topDestinationSlugs = [
  {
    slug: 'Miami--FL--United-States',
    title: 'slug--Miami--FL--United-States_title',
    subtitle: 'slug--Miami--FL--United-States_subtitle',
  },
  {
    slug: 'San-Diego--CA--United-States',
    title: 'slug--San-Diego--CA--United-States_title',
    subtitle: 'slug--San-Diego--CA--United-States_subtitle',
  },
  {
    slug: 'Key-Largo--FL--United-States',
    title: 'slug--Key-Largo--FL--United-States_title',
    subtitle: 'slug--Key-Largo--FL--United-States_subtitle',
  },
  {
    slug: 'Lake-Travis--TX--United-States',
    title: 'slug--Lake-Travis--TX--United-States_title',
    subtitle: 'slug--Lake-Travis--TX--United-States_subtitle',
  },
  {
    slug: 'Lake-Lanier--GA--United-States',
    title: 'slug--Lake-Lanier--GA--United-States_title',
    subtitle: 'slug--Lake-Lanier--GA--United-States_subtitle',
  },
  {
    slug: 'Newport-Beach--CA--United-States',
    title: 'slug--Newport-Beach--CA--United-States_title',
    subtitle: 'slug--Newport-Beach--CA--United-States_subtitle',
  },
  {
    slug: 'Destin--FL--United-States',
    title: 'slug--Destin--FL--United-States_title',
    subtitle: 'slug--Destin--FL--United-States_subtitle',
  },
  {
    slug: 'Lake-Tahoe--United-States',
    title: 'slug--Lake-Tahoe--United-States_title',
    subtitle: 'slug--Lake-Tahoe--United-States_subtitle',
  },
  {
    slug: 'Chicago--IL--United-States',
    title: 'slug--Chicago--IL--United-States_title',
    subtitle: 'slug--Chicago--IL--United-States_subtitle',
  },
  {
    slug: 'Marathon--FL--United-States',
    title: 'slug--Marathon--FL--United-States_title',
    subtitle: 'slug--Marathon--FL--United-States_subtitle',
  },
  {
    slug: 'Lake-Norman--NC--United-States',
    title: 'slug--Lake-Norman--NC--United-States_title',
    subtitle: 'slug--Lake-Norman--NC--United-States_subtitle',
  },
  {
    slug: 'Toronto--Ontario--Canada',
    title: 'slug--Toronto--Ontario--Canada_title',
    subtitle: 'slug--Toronto--Ontario--Canada_subtitle',
  },
];

export default topDestinationSlugs;
